import _extends from "@babel/runtime/helpers/esm/extends";
var _path;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgDelivereasy = function SvgDelivereasy(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    width: 35,
    height: 35,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M19.698 8.335A7.17 7.17 0 0 0 17.5 8a7.082 7.082 0 0 0-2.198.335c-4.895 1.558-6.867 7.184-3.913 11.417 1.652 2.363 3.495 4.597 5.259 6.884.244.318.526.609.852.976.327-.367.609-.658.853-.976 1.764-2.287 3.607-4.52 5.258-6.884 2.955-4.233.982-9.859-3.912-11.417Zm-2.272 10.79c-2.155-.052-3.889-1.848-3.86-3.988.033-2.199 1.85-3.865 4.154-3.81 2.066.047 3.762 1.85 3.71 3.94-.05 2.122-1.908 3.912-4.004 3.859Z",
      fill: "currentColor"
    }))
  }));
};
export default SvgDelivereasy;